import React, { useState } from 'react';
import { Settings, Loader2, CheckCircle2, AlertCircle } from 'lucide-react';
import { API_URL } from '../../config';

// Bouton « Demander à gérer mon agent moi-même » : tant que l'équipe n'a pas autorisé la configuration autonome,
// le client peut la demander. L'équipe est prévenue sur Telegram et l'active ensuite depuis l'admin.
export default function SelfConfigRequest({ clientId, requested }) {
  const [sent, setSent] = useState(!!requested);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const send = async () => {
    setBusy(true); setError('');
    try {
      const res = await fetch(`${API_URL}/api/bot/config/${clientId}/request-self-config`, {
        method: 'POST', headers: { Authorization: `Bearer ${localStorage.getItem('auth_token')}` },
      });
      const data = await res.json();
      if (data.success) setSent(true); else setError(data.message || 'Demande impossible. Réessayez.');
    } catch (_) {
      setError('Connexion impossible. Réessayez.');
    } finally { setBusy(false); }
  };

  if (sent) {
    return (
      <div className="mt-3 flex items-start gap-2.5 rounded-xl border border-emerald-500/25 bg-emerald-500/10 p-3 text-xs text-emerald-200">
        <CheckCircle2 className="w-4 h-4 flex-shrink-0 mt-0.5" />
        <span>Demande envoyée : notre équipe a été prévenue. Vous recevrez un message dans votre boîte de réception dès que l'accès sera activé.</span>
      </div>
    );
  }
  return (
    <div className="mt-3 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-white/10 bg-white/5 p-3">
      <p className="text-xs text-gray-300 flex-1 min-w-[220px]">
        Votre agent est actuellement configuré par notre équipe. Vous voulez le gérer vous-même (produits, prix, réponses…) ? Demandez l'accès : notre équipe sera prévenue et l'activera.
      </p>
      <button onClick={send} disabled={busy}
        className="flex items-center gap-2 px-4 py-2 rounded-xl text-xs font-semibold bg-gradient-to-r from-violet-600 to-fuchsia-600 hover:opacity-90 disabled:opacity-50 text-white transition">
        {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Settings className="w-3.5 h-3.5" />}
        Demander à gérer mon agent moi-même
      </button>
      {error && <p className="w-full flex items-center gap-1.5 text-xs text-rose-300"><AlertCircle className="w-3.5 h-3.5" /> {error}</p>}
    </div>
  );
}
